import { Component, OnInit, ViewChild } from '@angular/core';
import {
  ScadenzaModRinvioComponent
} from '../../../common/components/fascicolo/scadenzario-rinvio/scadenza-mod-rinvio.component';
import { Adempimento } from '../../../common/models/adempimento';
import { SearchAdempimentiResponse } from '../../../common/models/dto/search-adempimenti-response';
import { TipoScadenza } from '../../../common/models/tipologiche/tipo-scadenza';
import { ServicePathsSettings } from '../../configuration/service-paths-settings';

import { HelpersService } from '../../services/helpers.service';
import { OperationsService } from '../../services/operations.service';
import { ViewManagerService } from '../../services/view-manager-service';

@Component({
    selector: 'main [prossimi-adempimenti-view]',
  templateUrl: 'prossimi-adempimenti-view.component.html',
  host: { '[attr.id]': '\'content\'' }
})

export class ProssimiAdempimentiViewComponent implements OnInit {

  prossimiAdempimentiList: Adempimento[] = [];
  adempimenti: Adempimento[] = [];
  tipiScadenze: TipoScadenza[] = [];
  searchAdempimentiResponse: SearchAdempimentiResponse;
  waitResponseSearch: boolean = false;
  numToView: number = 0;
  isViewAll: boolean = true;
  @ViewChild('modaleRinvioScadenza') modaleRinvioScadenza: ScadenzaModRinvioComponent;

  constructor(protected operationService: OperationsService,
              private helpers: HelpersService,
              private viewManager: ViewManagerService) {}

  ngOnInit() {
    this.viewManager.svuotaMenu();
    this.helpers.getTipiScadenza().subscribe(response => this.tipiScadenze = response);
    this.loadProssimiAdempimenti(ServicePathsSettings.DEFAULT_DIMENSION_RESEARCH_ADEMPIMENTI);
  }

  loadProssimiAdempimenti(size: number) {
    this.waitResponseSearch = true;
    this.operationService.getProssimiAdempimenti({fromResult: this.prossimiAdempimentiList.length, size: size}).subscribe(response => this.prossimiAdempimentiListResult(response));
  }

  prossimiAdempimentiListResult(response: SearchAdempimentiResponse) {
    this.searchAdempimentiResponse = response;
    if (response.adempimenti.length > 0) {
      this.prossimiAdempimentiList = this.prossimiAdempimentiList.concat(response.adempimenti);
    }
    this.adempimenti = this.prossimiAdempimentiList;
    this.waitResponseSearch = false;
    this.getTipiScadenza();
  }

  getTipiScadenza() {
    for (let tipoScadenza of this.tipiScadenze) {
      this.filterScadenza(tipoScadenza.id);
      if (document.getElementById('ts-' + tipoScadenza.id)) {
        document.getElementById('ts-' + tipoScadenza.id).classList.remove('active');
      }
    }
    this.filterScadenza('');
    if (document.getElementById('all')) {
      document.getElementById('all').classList.add('active');
    }
  }

  filterScadenza(idLabelScadenza: string): void {
    if (idLabelScadenza === '') {
      this.isViewAll = true;
      this.adempimenti = this.prossimiAdempimentiList.filter((adempimento: Adempimento) => adempimento.tipoScadenza.label !== null);
    } else {
      this.isViewAll = false;
      this.adempimenti = this.prossimiAdempimentiList.filter((adempimento: Adempimento) => adempimento.tipoScadenza.label === idLabelScadenza);
    }
  }

  adempimentoEvaso() {
    if (this.searchAdempimentiResponse && this.searchAdempimentiResponse.setNumeroAdempimentiTotali > 0) {
      this.searchAdempimentiResponse.setNumeroAdempimentiTotali = this.searchAdempimentiResponse.setNumeroAdempimentiTotali - 1;
    }
  }

  adempimentoRinviato() {
    let lunghezzaAttuale: number = this.prossimiAdempimentiList.length;
    this.prossimiAdempimentiList = [];
    this.adempimenti = [];
    this.loadProssimiAdempimenti(lunghezzaAttuale);
  }

  apriModaleRinvio(adempimento: Adempimento) {
    this.modaleRinvioScadenza.inizializza(ServicePathsSettings.URL_RINVIO_ADEMPIMENTO, adempimento, adempimento.idFascicolo, true);
  }
}
